import { ReactNode } from "react";
import { z } from "zod";

export const OptionSchema = z.object({
	value: z.string(),
	label: z.string(),
	disabled: z.boolean().optional(),
	subtext: z.string().optional(),
	children: z.custom<ReactNode>().optional(),
});
